import type {
  PatientSymptom,
  SymptomGroup,
  SymptomGroupKey,
} from "@/types/appointments";

const SYMPTOM_GROUP_LABELS: Record<SymptomGroupKey, string> = {
  digestive: "Digestive",
  others: "Other",
  custom: "Custom",
};

const compareByLabel = (a: PatientSymptom, b: PatientSymptom) => {
  const al = a.symptoms?.name ?? a.custom_symptoms ?? "";
  const bl = b.symptoms?.name ?? b.custom_symptoms ?? "";
  return al.localeCompare(bl);
};

// Groups symptoms into Digestive / Other / Custom. Returns groups in a stable
// display order; callers decide whether to drop empty groups before rendering.
export const groupSymptomsByType = (
  symptoms: readonly PatientSymptom[]
): SymptomGroup[] => {
  const buckets: Record<SymptomGroupKey, PatientSymptom[]> = {
    digestive: [],
    others: [],
    custom: [],
  };

  for (const symptom of symptoms) {
    if (!symptom.symptoms) {
      buckets.custom.push(symptom);
      continue;
    }
    const type = symptom.symptoms.type === "digestive" ? "digestive" : "others";
    buckets[type].push(symptom);
  }

  return (Object.keys(buckets) as SymptomGroupKey[]).map((key) => ({
    key,
    label: SYMPTOM_GROUP_LABELS[key],
    items: buckets[key].sort(compareByLabel),
  }));
};
